import { createRemoteComponent } from '@remote-ui/core';

/**
 * Text block is used to render a block of text that occupies the full width available, like a paragraph.
 */
const TextBlock = createRemoteComponent('TextBlock');

export { TextBlock };
